const ArrowDownIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props} 
	>
		<path d="M11 5L7 9L3 5" strokeWidth="2"/>
	</svg>
)

export default ArrowDownIcon